export enum LivenessCheckCode {
  INVIVOEXPIRATION_CODE = 70001, // 活体识别过期
  NOBIOMETRICIDENTIFICANTION_CODE = 400013 // 未做活体
}
